import { render, staticRenderFns } from "./SettingsEmailDomain.vue?vue&type=template&id=0843d4f1&"
import script from "./SettingsEmailDomain.vue?vue&type=script&lang=js&"
export * from "./SettingsEmailDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports